// @ts-nocheck
import React, { useCallback, useState, useEffect } from 'react';
import { FormGroup, Intent } from '@blueprintjs/core';

import { MoneyInputGroup } from '@/components';
import { CLASSES } from '@/constants/classes';
import { CellType } from '@/constants';

// Input form cell renderer.
const MoneyFieldCellRenderer = ({
  row: { index, moneyInputGroupProps = {} },
  column: { id, fieldProps = {} },
  cell: { value: initialValue },
  payload: { errors, updateData, isBalanced, isAdmin },
}) => {
  const [value, setValue] = useState(initialValue);

  const handleFieldChange = useCallback((value) => {
    setValue(value);
  }, [setValue]);

  function isNumeric(data) {
    return (
      !isNaN(parseFloat(data)) && isFinite(data) && data.constructor !== Array
    );
  }

  const handleFieldBlur = () => {
    const updateValue = isNumeric(value) ? parseFloat(value) : value;
    updateData(index, id, updateValue);
  };

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const error = errors?.[index]?.[id];

  // Disable debit/credit fields for non-admin users on balanced journals
  const isAmountField = id === 'debit' || id === 'credit';
  const shouldDisable = isBalanced && !isAdmin && isAmountField;

  return (
    <FormGroup
      intent={error ? Intent.DANGER : null}
      className={CLASSES.FILL}>
      <MoneyInputGroup
        value={value}
        // prefix={'$'}
        onChange={handleFieldChange}
        onBlur={handleFieldBlur}
        disabled={shouldDisable || fieldProps.disabled}
        {...moneyInputGroupProps}
      />
    </FormGroup>
  );
};

MoneyFieldCellRenderer.cellType = CellType.Field;

export default MoneyFieldCellRenderer;
